// extracted by mini-css-extract-plugin
export default {"root":"NotificationDialog_root__STzJn"};